import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Components
import TableCountDropdown from '../../../../components/TableCountDropdown';
import ResponsiveTable from '../../../../components/ResponsiveTable';
import ReportsHarvestInspectionsPagination from './components/ReportsHarvestInspectionsPagination';
import ReportsHarvestInspectionsTableHead from './components/ReportsHarvestInspectionsTableHead';
import ReportsHarvestInspectionsTableRow from './components/ReportsHarvestInspectionsTableRow';

// Selectors
import { selectIds } from './selectors';

interface Props {
    ids?: number[];
    jobType?: string;
    defaultCount: number;
    defaultSort: string;
}

export class ReportsHarvestInspectionsTable extends React.PureComponent<Props> {
    render() {
        const { ids, jobType, defaultCount, defaultSort } = this.props;
        const colSpan = jobType === 'INSPECTION' ? 12 : 6;
        return (
            <div>
                <ResponsiveTable style={{ marginTop: 0 }}>
                    <Table
                        selectable
                        sortable
                        // fixed
                        striped
                        singleLine
                        unstackable
                        size="small"
                    >
                        <ReportsHarvestInspectionsTableHead
                            jobType={jobType}
                            defaultSort={defaultSort}
                        />
                        <Table.Body>
                            {(!ids || !ids.length) && (
                                <Table.Row colSpan={colSpan} textAlign="center">
                                    <Table.Cell
                                        colSpan={colSpan}
                                        className="events-table-cell-padding"
                                    >
                                        There are no reports.
                                    </Table.Cell>
                                </Table.Row>
                            )}
                            {ids &&
                                ids.map(id => (
                                    <ReportsHarvestInspectionsTableRow
                                        eventId={id}
                                        key={id}
                                        jobType={jobType}
                                    />
                                ))}
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <TableCountDropdown defaultCount={defaultCount} />
                        <ReportsHarvestInspectionsPagination
                            defaultCount={defaultCount}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectIds
});

export default connect(mapStateToProps)(ReportsHarvestInspectionsTable);
